

































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import { throttle, download } from '@/utils/util'
import RevisitApi from '@/api/revisit'
import RecordSection from '@/components/task/RecordSection.vue'
import { REVISIT_FINISH } from '@/utils/const'

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'returnVisitTaskDetail',
	components: {
		PageLayout,
		RecordSection,
	},
})
export default class QueryList extends Vue {
	private addResurveyVisible: boolean = false
	private taskLog: any = []
	private taskLogVisible: boolean = false
	private order: any = {}
	private injured: any = {}
	private returnVisible: boolean = false
	private returnLoading: boolean = false
	private returnForm: any = {}
	private mediaOrder: any = []
	private mediaMap: any = {}
	private mediaInfoMap: any = {}
	private ws: any = ''
	private activeKey: any = '1'
	private timer: any = ''
	private expireTimer: any = ''
	private throttleOpenWS = throttle(10 * 1000)
	private once: boolean = false
	private exporting: boolean = false
	private visitorPhone: any = ''
	private cancelLoading: boolean = false
	private revokeDialogVisible: boolean = false
	private cancelForm: any = {}
	private auditCancelForm: any = {}
	private evaluateForm: any = {}
	private evaluateVisible: boolean = false
	private evaluateLoading: boolean = false
	private rate: number = 5
	private labelMap: any = {}
	private labelList: any = []
	private evaluateInfo: any = {}
	private auditCancelVisible: boolean = false
	private auditCancelLoading: boolean = false
	private postponeVisible: boolean = false
	private postponeLoading: boolean = false
	private postponeHours: any = 12
	private show: any = ''
	private visitorPopupShow: boolean = false
	private resurveyCountdown: any = 0
	private canResurvey: boolean = false
	private lastOrderInfo: any = ''
	private addForm: any = {}
	private operationList: any = []
	private addLoading: boolean = false
	private saving: boolean = false
	private orderDetail: any = {}
	private REVISIT_FINISH = REVISIT_FINISH

	private get revisitOptStatusList() {
		return this.$store.state.setting.revisitOptStatusList.filter(
			(item: any) => {
				// 10 正常 20 异常
				return ['20', '10'].includes(item.key)
			}
		)
	}

	private onTaskAdd() {
		this.addForm.validateFields(async (err: any, values: any) => {
			if (!err) {
				this.saving = true
				values.taskId = this.$route.params.id
				const res: any = await RevisitApi.save(values).finally(() => {
					this.saving = false
				})
				this.$message.success(res.message)
				this.getDetail()
			}
		})
	}

	private get showEdit() {
		const order = this.order
		const operationList = this.operationList
		if (order.taskStatus === '20') {
			if (!operationList || !operationList.length) {
				return true
			} else {
				const last = operationList[0]
				return last.revisitor === this.$store.state.user.userInfo.userId
			}
		} else {
			return false
		}
	}

	private back() {
		this.$router.go(-1)
	}

	private async startRevisit() {
		this.addLoading = true
		await RevisitApi.begin(this.$route.params.id).finally(() => {
			this.addLoading = false
		})
		this.getDetail()
	}

	private getDetail() {
		return RevisitApi.getDetail(this.$route.params.id).then((data: any) => {
			this.orderDetail = data.data
			this.order = data.data.order
			this.operationList = data.data.operationList
		})
	}

	private created() {
		this.addForm = this.$form.createForm(this)
	}

	private deactivated() {}

	private activated() {
		this.order = ''
		this.getDetail()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.$nextTick(() => {
			this.order = ''
			this.getDetail()
		})
		next()
	}

	private async cancelRevisit() {
		this.addLoading = true
		await RevisitApi.cancel(this.$route.params.id).finally(() => {
			this.addLoading = false
		})
		this.getDetail()
	}
}
